var React = require('react');

function Lu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#00a1de","d":"M0 240h640v240H0z","key":0}),React.createElement("path",{"fill":"#ed2939","d":"M0 0h640v240H0z","key":1}),React.createElement("path",{"fill":"#fff","d":"M0 160h640v160H0z","key":2})]);
}

Lu.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Lu;

Lu.default = Lu;
